import React from "react";
import { usePopup } from "../utils/PopupContext";

const Popup = () => {
  const { value, clearPopup } = usePopup();
  if (!value) return null;

  const isObject = typeof value === "object" && value !== null;
  const isPersistent = isObject && value.persistent;
  const buttonText = (isObject && value.startText) || "Close";

  const isNode =
    React.isValidElement(value) ||
    (isObject && React.isValidElement(value.content));
  const nodeContent = React.isValidElement(value)
    ? value
    : isObject && React.isValidElement(value.content)
    ? value.content
    : null;
  const textContent =
    typeof value === "string"
      ? value
      : isObject && value.text
      ? value.text
      : null;

  return (
    <div className="popup-overlay">
      <div className="popup-content" role="dialog" aria-modal="true">
        {isNode ? (
          <div className="popup-node">{nodeContent}</div>
        ) : (
          <p className="popup-text">{textContent}</p>
        )}
        <button className="popup-button" onClick={clearPopup}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default Popup;
